import { useDetailApi } from "../../../swr/useApi";
import { adminLoyaltyService } from "../../api_client";
import type { LoyaltyConfigDto } from "../../../api";

export function useLoyaltyConfig() {
    return useDetailApi<LoyaltyConfigDto>({
        key: "loyalty-config",
        serviceMethod: async () => await adminLoyaltyService.adminGetLoyaltyConfig(),
    });
}

